import { Box, Button, ButtonGroup } from "@mui/material";

interface LikertScaleProps {
  likertLength: number;
  answerValue: number | null;
  onChange: (value: number) => void;
  short?: boolean;
}

export const LikertScale: React.FC<LikertScaleProps> = ({
  likertLength,
  answerValue,
  onChange,
  short,
}) => {
  const selectValues = Array.from({ length: likertLength }, (_, i) => i + 1);

  const boxWidth = short ? "60%" : "90%";

  return (
    <Box width={boxWidth}>
      <ButtonGroup fullWidth variant="outlined" size="small">
        {selectValues.map((num) => (
          <Button
            key={num}
            variant={answerValue === num ? "contained" : "outlined"}
            onClick={() => onChange(num)}
          >
            {num}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};
